import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import { matchInteriorType } from 'rangeConfig/ivar/filters/selectedMenuProductFilters';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import replaceShelfAndOrganizer from 'rangeConfig/shared/behaviors/replaceShelfAndOrganizer';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseInterior',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: [
    {
      id: 'interior-selected-menu-interior',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      filters: [],
      behaviors: {
        productClicked: [replaceShelfAndOrganizer],
        productDropped: [replaceShelfAndOrganizer]
      },
      productTypes: [
        ProductType.IVAR_SHELF_PINE,
        ProductType.IVAR_SHELF_FELT,
        ProductType.IVAR_SHELF_METAL,
        ProductType.IVAR_CLOTHES_RAIL,
        ProductType.IVAR_BOTTLE_RACK,
        ProductType.IVAR_DRAWER_PINE,
        ProductType.IVAR_DRAWER_METAL,
        ProductType.IVAR_STORAGE_BOX,
        ProductType.IVAR_TABLE,
        ProductType.IVAR_CORNER_SHELF
      ],
      productFilters: [matchInteriorType]
    }
  ]
};

export default selectedMenu;
